import { api } from './api';
import type {
  CreateProjectDomainRequest,
  ProjectDomainListResponse,
  ProjectDomainResponse,
} from '../types/projectDomain';

export const projectDomainApi = {
  list: (projectId: string) =>
    api.get<ProjectDomainListResponse>(`/api/projects/${projectId}/domains`),

  create: (projectId: string, data: CreateProjectDomainRequest) =>
    api.post<ProjectDomainResponse>(`/api/projects/${projectId}/domains`, data),

  get: (projectId: string, domainId: string) =>
    api.get<ProjectDomainResponse>(`/api/projects/${projectId}/domains/${domainId}`),

  delete: (projectId: string, domainId: string) =>
    api.delete<{ success: boolean; message?: string }>(
      `/api/projects/${projectId}/domains/${domainId}`
    ),

  verify: (projectId: string, domainId: string) =>
    api.post<ProjectDomainResponse>(`/api/projects/${projectId}/domains/${domainId}/verify`),

  setPrimary: (projectId: string, domainId: string) =>
    api.put<ProjectDomainResponse>(`/api/projects/${projectId}/domains/${domainId}/primary`),
};
